export const moneyCommaSeparator = (value) =>
  value === Infinity || value === -Infinity || Number.isNaN(value)
    ? "0.00"
    : value?.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export const moneyCommaSeparatorPoint = (value) =>
  value === Infinity || value === -Infinity || Number.isNaN(value)
    ? "0.00"
    : value?.toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

export const numberToCurrency = (value) =>
  value?.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  });

export const exponentialToDecimal = (value) => {
  if (value.toString().includes("e")) {
    return Number(value).toFixed(2);
  }
  return String(value);
};

export const handleInfinityOrNan = (value) => {
  if (value === Infinity || value === -Infinity || Number.isNaN(value)) {
    return 0;
  }
  return value;
};

export const formatDate = (date) => {
  if (date) {
    return date.replace(/-/g, "/");
  }
  return date;
};

export const errorHandler = (error) => {
  if (error.status === 401) return "Please login again, session expired";
  return error.errors.message || "Something went wrong, please try again later";
};

export const copyTextToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    return false;
  }
};
